/**
 * Presentation Layer - DuplicateErrorDialog Component
 * 重複エラーダイアログコンポーネント
 */

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Box,
} from '@mui/material';
import { Warning as WarningIcon, ContentCopy as DuplicateIcon } from '@mui/icons-material';

/**
 * Props定義
 */
export interface DuplicateErrorDialogProps {
  /** ダイアログが開いているか */
  open: boolean;
  /** 重複データの行番号リスト */
  duplicates: string[];
  /** 閉じる時のコールバック */
  onClose: () => void;
}

/**
 * 重複エラーダイアログコンポーネント
 */
export const DuplicateErrorDialog: React.FC<DuplicateErrorDialogProps> = ({
  open,
  duplicates,
  onClose,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <WarningIcon color="warning" />
        重複データが検出されました
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          以下のデータは既に登録されているため、スキップされました。
        </Typography>

        <Box
          sx={{
            maxHeight: 300,
            overflow: 'auto',
            bgcolor: 'grey.50',
            borderRadius: 1,
          }}
        >
          <List dense>
            {duplicates.map((duplicate, index) => (
              <ListItem key={index}>
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <DuplicateIcon fontSize="small" color="warning" />
                </ListItemIcon>
                <ListItemText primary={duplicate} />
              </ListItem>
            ))}
          </List>
        </Box>

        <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
          合計 {duplicates.length} 件の重複データ
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained">
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
};
